import { createSelector } from 'reselect'
import * as R from 'ramda'

import { transformCljGroupedLog } from 'src/lib/data/transform'

import * as dbSelectors from 'src/store/db/selectors/base'
import * as boardPointSelectors from 'src/lib/selectors/board/points'

import { boardSelector } from './base'
import { boardSettingsSelector } from './board'

// Maps board object selectors to redux tree

export const pointsEnabledSelector = createSelector(
  boardSelector,
  boardPointSelectors.pointsEnabledSelector
)

export const pointMaxSelector = createSelector(
  boardSelector,
  boardPointSelectors.pointMaxSelector
)

export const gradingPeriodsSelector = createSelector(
  boardSelector,
  boardPointSelectors.gradingPeriodsSelector
)

export const gradingPeriodsLengthSelector = createSelector(
  boardSelector,
  boardPointSelectors.gradingPeriodsLengthSelector
)

export const startDateSelector = createSelector(
  boardSelector,
  boardPointSelectors.startDateSelector
)

export const startDateDisabledSelector = createSelector(
  boardSelector,
  boardPointSelectors.startDateDisabledSelector
)

export const startDateFormattedSelector = createSelector(
  boardSelector,
  boardPointSelectors.startDateFormattedSelector
)

export const endDateSelector = createSelector(
  boardSelector,
  boardPointSelectors.endDateSelector
)

export const endDateDisabledSelector = createSelector(
  boardSelector,
  boardPointSelectors.endDateDisabledSelector
)

export const currentGradingPeriodIndexSelector = createSelector(
  boardSelector,
  boardPointSelectors.currentGradingPeriodIndexSelector
)

export const currentGradingPeriodSelector = createSelector(
  boardSelector,
  boardPointSelectors.currentGradingPeriodSelector
)

export const currentGradingPeriodEndDateSelector = createSelector(
  boardSelector,
  boardPointSelectors.currentGradingPeriodEndDateSelector
)

export const pointsConfiguredSelector = createSelector(
  boardSelector,
  boardPointSelectors.pointsConfiguredSelector
)

export const metricsSelector = createSelector(
  boardSelector,
  boardPointSelectors.metricsSelector
)

export const participationGradeSelector = createSelector(
  boardSelector,
  boardPointSelectors.participationGradeSelector
)

export const participationGradePercentSelector = createSelector(
  boardSelector,
  boardPointSelectors.participationGradePercentSelector
)

export const weeklyMaxSelector = createSelector(
  boardSelector,
  boardPointSelectors.weeklyMaxSelector
)

export const weeklyTargetSelector = createSelector(
  boardSelector,
  boardPointSelectors.weeklyTargetSelector
)

export const periodTargetSelector = createSelector(
  boardSelector,
  boardPointSelectors.periodTargetSelector
)

export const freeformPointsActiveSelector = createSelector(
  boardSelector,
  boardPointSelectors.freeformPointsActiveSelector
)

export const freeformPointsGradingVisibleSelector = createSelector(
  boardSettingsSelector,
  R.pipe(
    R.either(
      R.prop(':board-settings/hide-grading'),
      R.pipe(R.prop(':board-settings/points-target-max'), R.equals(-1))
    ),
    R.not
  )
)

export const gradingEnabledSelector = createSelector(
  boardSettingsSelector,
  R.prop(':board-settings/grading-enabled')
)

export const groupedLogSelector = createSelector(
  dbSelectors.dbSelector,
  boardSelector,
  (db, board) => {
    const dbLog = R.path([board[':db/id'], 'log'], db)
    if (dbLog) {
      return transformCljGroupedLog(dbLog)
    }

    return R.path(['points', 'log'])
  }
)

export const distanceToGoalSelector = createSelector(
  boardSelector,
  boardPointSelectors.distanceToGoalSelector
)
